module.exports = __webpack_public_path__ + "img/IMG_6445 1.7176c9c4.png";